import React from "react";
import Icon from "@ant-design/icons";


const StaffPrinterSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M38.06,13.71h-2.05v-4.79c0-1.79-1.46-3.25-3.25-3.25H15.46c-1.79,0-3.25,1.46-3.25,3.25v4.79h-2.05c-2.63,0-4.77,2.14-4.77,4.77v13.34c0,2.63,2.14,4.77,4.77,4.77h2.05v3.99c0,1.79,1.46,3.25,3.25,3.25h17.31c1.79,0,3.25-1.46,3.25-3.25v-3.99h2.05c2.63,0,4.77-2.14,4.77-4.77v-13.34c0-2.63-2.14-4.77-4.77-4.77ZM14.71,8.92c0-.41.33-.75.75-.75h17.31c.41,0,.75.33.75.75v4.79H14.71v-4.79ZM33.51,40.57c0,.41-.33.75-.75.75H15.46c-.41,0-.75-.33-.75-.75v-11.87c0-.41.33-.75.75-.75h17.31c.41,0,.75.33.75.75v11.87ZM40.32,31.81c0,1.25-1.02,2.27-2.27,2.27h-2.05v-5.39c0-1.79-1.46-3.25-3.25-3.25H15.46c-1.79,0-3.25,1.46-3.25,3.25v5.39h-2.05c-1.25,0-2.27-1.02-2.27-2.27v-13.34c0-1.25,1.02-2.27,2.27-2.27h27.89c1.25,0,2.27,1.02,2.27,2.27v13.34Z" />
        <path d="M29.33,31.14h-10c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h10c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z" />
        <path d="M29.33,35.73h-10c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h10c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z" />
        <path d="M37.04,18.41h-1.09c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h1.09c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z" />
    </svg>
);

const StaffPrinterIcon = (props) => <Icon { ...props } component={ StaffPrinterSvg } />;

export default StaffPrinterIcon;

